import { switchImg } from '../../../../../../../../../theme/images';
import { StubbornToolboxProperties } from '../../../../../../../../business/StubbornToolboxMapping';

export const toolbox: StubbornToolboxProperties = {
  name: 'switch',
  label: 'Switch',
  category: 'Inputs',
  image: switchImg,
};
